import { Accordion, Col, Container, Row } from "react-bootstrap";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useEffect, useState } from "react";

export default function KIYGGames() {
  const [GAMES, setGAMES] = useState([]);

  useEffect(() => {
    async function fetchGames() {
      const games = await fetch("data/kiyg25-games-data.json");
      const gamesList = await games.json();
      setGAMES(gamesList);
    }
    fetchGames();
  }, []);

  const games = [
    {
      title: "शूटिंग",
      description:
        "शूटिंग एक ऐसा खेल है जिसमें सटीकता और एकाग्रता बेहद ज़रुरी है। यह ओलंपिक खेल में एक प्रमुख डिसिप्लीन रहा है और एथेंस 1896 में आयोजित आधुनिक ओलंपिक खेल में शामिल 9 खेल में से एक है।ओलंपिक की शूटिंग स्पर्धा में तीन तरह की बंदूक (गन) का इस्तेमाल किया जाता है: राइफल, पिस्टल और शॉटगन। राइफल और पिस्टल स्पर्धाओं में एथलीट इनडोर शूटिंग रेंज में स्थिर टारगेट पर निशाना लगाते हैं जबकि शॉटगन स्पर्धा का आयोजन आउटडोर में होता है, जहां निशानेबाजों को हवा में फेंके गए लक्ष्यों पर निशाना साधना होता है।",
      // path: "/kiyg25-shooting",
      path: "#",
    },
    {
      title: "तीरंदाजी",
      description:
        "तीरंदाजी एक ऐसा खेल है जिसमें फोकस, सब्र और एकाग्रता को बहुत महत्व दिया जाता है। देखते ही देखते आर्चरी ने पूरे विश्व में अपनी एक अलग ही जगह बना ली है। तीरंदाजी में, खिलाड़ी एक निश्चित दूरी से लक्ष्य पर तीर चलाकर अधिक अंक प्राप्त करने की कोशिश करते हैं. तीरंदाजी के लिए मुख्य उपकरण धनुष, तीर, और लक्ष्य होते हैं. तीरंदाजी के कई प्रकार हैं, जिनमें लक्ष्य तीरंदाजी (target archery), फ़ील्ड तीरंदाजी (field archery), और इनडोर तीरंदाजी (indoor archery) शामिल हैं.",
      // path: "/link2",
      path: "#",
    },
    {
      title: "बैडमिंटन",
      description:
        "बैडमिंटन दो खिलाड़ियों या युगल टीमों द्वारा कोर्ट पर खेला जाने वाला एक रैकेट-एंड-शटल खेल है। बैडमिंटन एक रैकेट और शटल से खेला जाने वाला खेल है। यह एक इनडोर गेम है, जिसे दो (सिंगल्स) या चार (डबल्स) खिलाड़ी खेल सकते हैं। इसका उद्देश्य शटल को नेट के पार मारना और यह सुनिश्चित करना होता है कि विपक्षी खिलाड़ी उसे ठीक से वापिस न मार सके।",
      // path: "/link3",
      path: "#",
    },
    {
      title: "बास्केटबॉल",
      description:
        "बास्केटबॉल एक लोकप्रिय टीम खेल है, जिसमें दो टीमें एक-दूसरे के खिलाफ़ 10 फीट (3.048 मीटर) ऊंचे घेरे (गोल) में, संगठित नियमों के तहत एक गेंद डाल कर अंक अर्जित करने की कोशिश करती  है। गेंद को ऊपर से टोकरी के आर-पार फेंक कर अंक बनाए जाते हैं; खेल के अंत में अधिक अंकों वाली टीम जीत जाती है। कोर्ट में गेंद को उछालते हुए या साथियों के बीच आदान-प्रदान करके आगे बढ़ाया जाता है।",
      // path: "/link4",
      path: "#",
    },
    {
      title: "सेपकटाकरा",
      description:
        "सेपक टाकरा एक अनूठा खेल है, जिसे 'किक वॉलीबॉल' भी कहा जाता है। यह खेल बैडमिंटन कोर्ट जैसे मैदान पर खेला जाता है, जिसमें खिलाड़ी पैर, सिर, छाती और घुटनों से गेंद को मारते हैं। सेपक टाकरा बैडमिंटन कोर्ट के समान मैदान में खेला जाता है। इस कोर्ट की लंबाई 13.40 मीटर और चौड़ाई 6.19 मीटर होती है। मैदान को एक रेखा द्वारा दो हिस्सों में बांटा जाता है, जिसकी मोटाई 2 सेंटीमीटर होती है।",
      // path: "/link5",
      path: "#",
    },
  ];
  return (
    <>
      {/* list of bootstrap accordions */}
      <Breadcrumb
        pageName={KIYGGames}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      <Container>
        <Accordion defaultActiveKey={"0"}>
          <Row>
            {GAMES?.map((game, index) => (
              <Col md={4}>
                <Accordion.Item
                  className="col-md-4"
                  eventKey={`${index}`}
                  key={index}
                  style={{
                    margin: 20,
                    padding: 20,
                    width: "100%",
                    backgroundColor: "#0b244d",
                    color: "white",
                  }}
                >
                  <Accordion.Header style={{ color: "white" }}>
                    {game.title}
                  </Accordion.Header>
                  <Accordion.Body
                    style={{
                      margin: 5,
                      padding: 5,
                      backgroundColor: "#0b244d",
                      color: "white",
                    }}
                  >
                    {game.description}
                  </Accordion.Body>
                </Accordion.Item>
              </Col>
            ))}
          </Row>
        </Accordion>
      </Container>
    </>
  );
}
